import { useEffect } from 'react';

function useSocketEventOnTranslate(props) {
  const { im, removeTranslateData } = props;

  const handleRemoveTranslateData = stream => {
    const { track_id } = stream;
    removeTranslateData(track_id);
  };

  useEffect(() => {
    im.on('endConversation', handleRemoveTranslateData);
    return () => {
      im.off('endConversation', handleRemoveTranslateData);
    };
  }, []);
}

export default useSocketEventOnTranslate;
